import React from 'react';
import Link from 'next/link';
import Container from '../Container';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.footer__content}>
          <div className={styles.footer__nav}>
            <div className={styles.footer__panel}>
              <ul className={styles.list}>
                <li className={styles.list__item}>
                  <Link href="/rules" data-qa-marker="user_agreement">
                    <a data-qa-marker="rules_page">Правила проекта</a>
                  </Link>
                </li>
                <li className={styles.list__item}>
                  <a
                    href="https://uchi.ru/eula"
                    target="_blank"
                    rel="noopener"
                    data-qa-marker="user_agreement"
                  >
                    Лицензионное соглашение
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a
                    href="https://uchi.ru/privacy"
                    target="_blank"
                    rel="noopener"
                    data-qa-marker="privacy_page"
                  >
                    Политика конфиденциальности
                  </a>
                </li>
              </ul>
            </div>
            <div className={styles.footer__panel}>
              <ul>
                <li className={styles.list__item}>
                  <a href="https://uchi.ru/products" target="_blank" rel="noopener">
                    Наши продукты
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a
                    href="https://uchi.ru/products/tutors"
                    target="_blank"
                    rel="noopener"
                  >
                    Репетиторы
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a
                    href="https://conf.uchi.ru/?utm_source=site&utm_medium=links&utm_campaign=augustovka24&utm_content=futter_otvet"
                    target="_blank"
                    rel="noopener"
                  >
                    Августовка Учи.ру
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a href="https://uchi.ru/schools" target="_blank" rel="noopener">
                    Каталог школ
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a
                    href="https://uchi.ru/podgotovka-k-uroku"
                    target="_blank"
                    rel="noopener"
                  >
                    Подготовка к уроку
                  </a>
                </li>
                <li className={styles.list__item}>
                  <a href="https://uchi.ru/znaniya" target="_blank" rel="noopener">
                    Учи.Знания
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.footer__social}>
            <h3 className={styles.footer__title}>Присоединяйся</h3>
            <ul className={styles.social}>
              <li>
                <a
                  className={`${styles.social__link} ${styles.social__link_vk}`}
                  href="https://vk.com/club157886777"
                  target="_blank"
                  rel="noopener"
                />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.footer__rights}>
          При копировании материалов uchi.ru/otvety ссылка на&nbsp;сайт обязательна.
          <br />© Учи.Ответы, 2015-{new Date().getFullYear()}
        </div>
      </Container>
    </footer>
  );
}
